import { useSearchParams } from "react-router-dom";

// Keeps a tab page's active tab in the URL as `?tab=<slug>`, so a hard
// refresh, a shared link or a redirect opens the same tab.
//
// Usage (drop-in for `useState(0)` on a TabPageLayout page):
//   const [activeTab, setActiveTab] = useUrlTab(["clients", "admins", "employees"]);
//
// `slugs`        one URL name per tab, in tab order (kebab-case). Keep them
//                stable: renaming a tab's label shouldn't break saved links.
// activeTab      index of the tab named in the URL; 0 when `?tab=` is missing
//                or doesn't match any slug.
// setActiveTab   (index) => writes `?tab=<slug>`, keeping every other query
//                param (fileId, status, ...). It replaces the history entry, so
//                Back leaves the page instead of stepping through tabs.
export default function useUrlTab(slugs) {
  const [searchParams, setSearchParams] = useSearchParams();

  const index = slugs.indexOf(searchParams.get("tab"));
  const activeTab = index === -1 ? 0 : index;

  const setActiveTab = (nextIndex) => {
    const slug = slugs[nextIndex];
    if (!slug) return;
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set("tab", slug);
        return next;
      },
      { replace: true }
    );
  };

  return [activeTab, setActiveTab];
}
